module.exports = __webpack_public_path__ + "img/external-icon.c7c7b65f.svg";